import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20abstract%20theater%20curtains%20and%20warm%20spotlight%20beams%2C%20luxurious%20deep%20red%20and%20gold%20tones%2C%20elegant%20movie%20premiere%20feel%2C%20dramatic%20lighting%20with%20soft%20gradients%2C%20no%20text%2C%20cinematic%20aesthetic&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="苹果视频 - 免费高清电影电视剧"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="苹果视频 - 免费高清电影电视剧流畅播放"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 w-full">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading leading-tight">
            免费高清电影电视剧
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-3 max-w-xl mx-auto">
            流畅播放不卡顿 · 海量资源每日更新
          </p>
          <p className="text-sm text-white/60 mb-8 max-w-lg mx-auto">
            汇聚<strong>香蕉视频</strong>、<strong>红桃视频</strong>、<strong>91视频</strong>、<strong>蜜桃视频</strong>等热门资源，全集免费在线观看
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/movie"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>开始观影
            </Link>
            <Link
              to="/category/tv"
              className="px-8 py-3 bg-white/20 text-white rounded-full font-medium text-sm hover:bg-white/30 transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-tv-line mr-2"></i>热播剧集
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}